import { Box, Image, Text } from '@chakra-ui/react';
import { type AnnouncementContentProps } from '../announcementConfig';
import applePassUpdateImage from '../../../../assets/images/announcements/apple-pass-update.svg';

const ApplePassUpdateContent = ({ dots }: AnnouncementContentProps) => (
  <Box>
    <Box px={10} pb={6} textAlign="center">
      <Text textStyle="heading3" lineHeight="1.2" color="white">
        Apple passes just got a
        <br />
        serious upgrade
      </Text>
      {dots}
    </Box>

    <Box bg="white">
      <Box px={10} py={6}>
        <Image
          src={applePassUpdateImage}
          alt="Apple pass old design vs new enhanced design comparison"
          w="85%"
          mx="auto"
        />
      </Box>

      <Text
        textStyle="bodyFamilyRegular"
        fontSize="16px"
        lineHeight="1.6"
        px={10}
        mb={2}
      >
        iOS 27 introduces a new pass style including{' '}
        <Text as="span" textStyle="bodyFamilyBold">
          full-screen artwork
        </Text>{' '}
        and{' '}
        <Text as="span" textStyle="bodyFamilyBold">
          tappable featured actions
        </Text>
        .
      </Text>
      <Text
        textStyle="bodyFamilyRegular"
        fontSize="14px"
        lineHeight="1.5"
        px={10}
        mb={6}
      >
        Available on generic, loyalty or event ticket templates.
      </Text>
    </Box>
  </Box>
);

export default ApplePassUpdateContent;
